import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Styles from './styles.module.css';
import Home from './Home';
import Shop from './Shop';
import Header from './Header';
import Footer from './Footer';
import Details from './Details';
import ShopDetails from './Shop/Details';
import About from './About';
import Contact from './Contact';
import aboutUsGif from '../Assets/footer/About_us.gif';
import shopGif from '../Assets/footer/Shop.gif';

export default class App extends Component {
  render(){
    return (
      <Router >
        <Header />
        <div className={Styles.container}>
          <Switch>
          <Route path="/details/:id">
              <Details />
            </Route>
            <Route exact path="/shop">
              <Shop />
              <Footer image={shopGif}/>
            </Route>
            <Route path="/shop/:id">
              <ShopDetails />
              <Footer image={aboutUsGif}/>
            </Route>
            <Route path="/about">
              <About />
              <Footer image={aboutUsGif}/>
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/">
              <Home />
              <Footer image={aboutUsGif}/>
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}